import { render, staticRenderFns } from "./ForeignSupplierForm.vue?vue&type=template&id=2f4ccaae&"
import script from "./ForeignSupplierForm.vue?vue&type=script&lang=js&"
export * from "./ForeignSupplierForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ForeignSupplierForm.vue?vue&type=custom&index=0&blockType=foreign_supplier"
if (typeof block0 === 'function') block0(component)

export default component.exports